// Vendor imports
const Promise = require('bluebird')

// This bridge is to support Wiggin components inside Client V2 targets
function requireBridge(fn) {
  if (typeof window === 'undefined') {
    // Bridged components are a no-op on the server-side
    return () => Promise.resolve()
  }
  return function (...args) {
    if (typeof wiggin === 'undefined') {
      // This assumes a global `app` exists, and has a Redux `store`
      // which is a pattern implied by client-v2/common/client.js
      setupBridge(app.store)
    }
    return Promise.resolve(fn.apply(null, args))
  }
}

function setupBridge(store) {
  // This is just the bare minimum to get the bridged stuff working
  const { env, user } = store.getState()
  window.wiggin = {
    user: user.toJS(),
    // Needed for mix-edit-modal
    '_csrf': env.csrfToken,
    // Needed for mix-select-modal
    articlePlaceholder: env.articlePlaceholder,
    // Needed for add-url extension promos
    browser: env.browser.toJS()
  }
}

module.exports = requireBridge
